import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon.js";
class LeavingQueueView extends Component {
  render() {
    return /* @__PURE__ */ jsxs("div", { id: "queue-view", children: [
      /* @__PURE__ */ jsxs("div", { className: "header", children: [
        /* @__PURE__ */ jsx(ChatIcon, { className: "large" }),
        /* @__PURE__ */ jsx("span", { className: "dpd-customer-services", children: "DPD Customer Services" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "message", children: [
        /* @__PURE__ */ jsx("span", { className: "whoa-there", children: "Whoa there!" }),
        /* @__PURE__ */ jsx("span", { className: "if-leave-now", children: "If you leave now you will lose your place in the queue" })
      ] }),
      /* @__PURE__ */ jsxs("div", { id: "leaving-queue", children: [
        /* @__PURE__ */ jsx("button", { onClick: this.props.onLeave, children: "Leave the queue" }),
        /* @__PURE__ */ jsx("button", { className: "flat-white-reverse", onClick: this.props.onBack, children: "Stay in the queue" })
      ] })
    ] });
  }
}
LeavingQueueView.propTypes = {
  onLeave: PropTypes.func,
  onBack: PropTypes.func
};
export {
  LeavingQueueView as default
};
//# sourceMappingURL=LeavingQueueView.js.map
